import { render } from "./BloodUnitsReportsTab.vue?vue&type=template&id=7eb5b2da"
import script from "./BloodUnitsReportsTab.vue?vue&type=script&lang=js"
export * from "./BloodUnitsReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__